import React from 'react'
import Img from 'react-cool-img'
import classNames from 'classnames/bind'
import { LINK_TO_INFO } from 'constants/links'
import { withLocalization, Text as TextType } from 'hocs/localization'
import Heading from 'elements/Heading'
import Text from 'elements/Text'
import loadingStep1 from './assets/step1-min.png'
import step1 from './assets/step1.png'
import loadingStep2 from './assets/step2-min.jpg'
import step2 from './assets/step2.jpg'
import loadingStep3 from './assets/step3-min.jpg'
import step3 from './assets/step3.jpg'
import * as styles from './HowToWork.scss'

const cx = classNames.bind(styles)

interface IProps {
  t: TextType,
}

const HowToWork: React.FC<IProps> = ({ t }) => (
  <section className={styles.root}>
    <div className='container'>
      <div className='row'>
        <div className='col-12'>
          <header className={styles.header}>
            <Heading title={t('header')} size={2} styleType='sectionHeader'/>
            <Text size='xLarge' smSize='large'>{t('description')}</Text>
          </header>
        </div>
        <div className={cx('col-12', 'steps')}>
          <div className='row'>
            <div className='col-12'>
              <div className={styles.step}>
                <div>
                  <Heading title={t('step1.header')} size={4} styleType='smallSize' />
                  <Text>{t('step1.description')}</Text>
                </div>
                <Img
                  className={cx('image', 'imageRight')}
                  placeholder={loadingStep1}
                  src={step1}
                />
              </div>
            </div>
            <div className='col-12'>
              <hr className={cx('line', 'line1')} />
            </div>
            <div className='col-12'>
              <div className={styles.step}>
                <Img
                  className={cx('image', 'imageLeft')}
                  placeholder={loadingStep2}
                  src={step2}
                />
                <div>
                  <Heading title={t('step2.header')} size={4} styleType='smallSize' />
                  <Text>{t('step2.description')}</Text>
                </div>
              </div>
            </div>
            <div className='col-12'>
              <hr className={cx('line', 'line2')} />
            </div>
            <div className='col-12'>
              <div className={styles.step}>
                <div>
                  <Heading title={t('step3.header')} size={4} styleType='smallSize' />
                  <Text>{t('step3.description')}</Text>
                </div>
                <Img
                  className={cx('image', 'imageRight')}
                  placeholder={loadingStep3}
                  src={step3}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.actualSavings}>
          <Text size='xSmall'>
            <div>
              {t('home.actualSavings1')}
              <a href={LINK_TO_INFO} target='_blank' className={styles.link} >
                {t('home.link')}
              </a>
            </div>
            <div>{t('home.actualSavings2')}</div>
          </Text>
        </div>
      </div>
    </div>
  </section>
)

export default withLocalization('home.main.howToWork')(HowToWork)
